import voteService from '@/services/vote.service';
import moment from 'moment';
const state = {
  id: null,
  identifier: null,
  name: null,
  has_voted: null,
  section_id: null,
  created: null,
  updated: null,
  list: [],
  listLength: 0,
  status: '',
  election: '',
  votedOn: '',
  electionName: '',
  voteOn: '',
  electionId: '',
  msgError: ''
};

const getters = {
  id: state => {
    return state.id;
  },
  has_voted: state => {
    return state.has_voted;
  },
  identifier: state => {
    return state.identifier;
  },
  name: state => {
    return state.name;
  },
  section_id: state => {
    return state.section_id;
  },
  list: state => {
    return state.list;
  },
  listLength: state => {
    return state.listLength;
  }
};
const mutations = {
  save: (state, payload) => {
    state.id = payload.id;
    state.status = payload.response.status;
    state.msgError = payload.response.data;
  },
  get: (state, payload) => {
    state.electionName = payload.election;
    state.identifier = payload.identifier;
    state.name = payload.name;
    state.votedOn = moment.utc(payload.voted_on).format('DD/MM/YYYY HH:mm:ss');
    state.has_voted = payload.has_voted;
  }
};

const actions = {
  save: async ({ commit }, payload) => {
    try {
      const response = await voteService.save(payload);
      payload.response = response;
      commit('save', payload);
    } catch (error) {
      if (error) {
        alert(error);
      }
    }
  },
  get: async ({ commit }, { idElection }) => {
    const response = await voteService.get(idElection);
    commit('get', response.data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
